module.exports = __webpack_public_path__ + "static/media/icon_mozilla.4c2798be.svg";